<template>
  <div class="mineBox">
    <div class="head">
      <div class="back-btn" @click="$router.go(-1)">
        <i class="el-icon-arrow-left"></i>
      </div>
      <mu-card-header
          class="user-info"
          style=""
          :title="userinfo.username"
          :sub-title="userinfo.mobile"
      >
        <mu-avatar slot="avatar">
          <img :src="userinfo.userhead || defaultHead"/>
        </mu-avatar>
        <div class="operate" @click="handleNext('/admin/setting')">
          <div>
            <img src="@/assets/image/user/user-image_4.png" alt=""/>
          </div>
        </div>
      </mu-card-header>
    </div>

    <div class="mineCard">
      <div class="card-text">账户余额（元）</div>
      <div class="card-center">
        <div class="card-price">{{ handleControlNumber(MyData || 0, 2) }}</div>
        <div class="card-cash" @click="showtixian">立即提现</div>
      </div>
      <div class="card-bottom">
        <div class="card-info">
          <p>
            今日收益（元）
          </p>
          <p>
            {{ handleControlNumber(todaymoney || 0,2) }}
          </p>
        </div>
        <div class="card-info">
          <p>
            本月收益（元）
          </p>
          <p>
            {{ handleControlNumber(monthmoney || 0, 2) }}
          </p>
        </div>
      </div>
    </div>
    <div class="operate-box">
      <div class="list-item" @click="handleNext('/admin/drawcash')">
        <div class="before">
          <img src="@/assets/image/user/user-image_1.png"/>
          <span>提现记录</span>
        </div>
        <i class="el-icon-arrow-right icon-box"></i>
      </div>
      <div class="list-item" @click="handleNext('/admin/bind_wechat')" v-if="!is_bind_wx">
        <div class="before">
          <img src="@/assets/image/user/user-image_2.png"/>
          <span>绑定微信</span>
        </div>
        <i class="el-icon-arrow-right icon-box"></i>
      </div>
      <div class="list-item" @click="handleLogout()">
        <div class="before">
          <img src="@/assets/image/user/user-image_3.png"/>
          <span>退出登录</span>
        </div>
      </div>

    </div>
  </div>
</template>
<script>

import {
  getMyData,
  getDayProfit,
  loginOut,
  getUserInfo,
  getMonProfit, getInfoByKey,getWebConfig
} from "@/api/newApi";
import {Toast} from "vant";
import store from "store";
import {digitUtil} from "@/utils/utils";

export default {
  components: {},
  data() {
    return {
      form: {},
      defaultHead: null,
      retypePassword: "",
      MyData: 0,
      tixianUnavailble: false,
      todaymoney: 0,
      monthmoney: 0,
      dialogShow: false,
      userinfo: {
        userhead: "",
        username: "",
        mobile: "",
      },
      is_bind_wx:false,
    };
  },
  created() {
    this.getConfigData("dls_login_logo");
  },
  mounted() {
    getMyData().then((res) => {
      if (res.data) {
        this.MyData = res.data.amount;
      }
      if (this.MyData == 0) {
        this.tixianUnavailble = true;
      }
    });
    getDayProfit().then((res) => {
      this.todaymoney = res.data.sumOrdergold;
    });
    getMonProfit().then((res) => {
      this.monthmoney = res.data.sumOrdergold;
    });
    this.userinfo.username = store.get("adminuser").adminuser.realName;
    this.userinfo.userhead = store.get("adminuser").adminuser.headImage;
    this.userinfo.mobile = store.get("adminuser").adminuser.mobile;

    this.getUserData();
  },
  methods: {
    handleControlNumber: digitUtil,
    getConfigData(value) {
      let param = {
        configKey: value,
      };
      // getInfoByKey(param).then((res) => {
      //   if (res.data) {
      //     this.defaultHead = res.data;
      //   }
      // });

      getWebConfig(param).then((res) => {
        if (res.data) {
          this.defaultHead = res.data.defaultAgentAvator;
        }
      });
    },
    handleNext(url) {
      this.$router.push(url);
    },
    handleLogout() {
      let that = this;
      this.$dialog({
        title: "提示",
        content: "是否确定退出当前账号？",
        closeBtn: false,
        onOkBtn(event) {
          window.localStorage.removeItem("token");
          loginOut().then((res) => {
            if (res.message.code == 0) {
              that.$toast.text("正在退出");
              setTimeout(() => {
                that.$router.push({
                  path: "/login",
                });
              }, 800);
            } else {
              that.$toast.text(res.message.message);
            }
          });
          this.close();
        },
      });
    },
    showtixian() {
      if (this.tixianUnavailble) {
        Toast("当前可提现余额为0，无法提现");
        return false;
      }
      getUserInfo().then((res) => {
        if (res.message.status == 200 && res.data.weixinOpenid) {
          this.$router.push({
            path: "/admin/tixian",
          });
        } else {
          Toast("请先绑定微信");
          this.$router.push("/admin/balance");
        }
      });
    },
    getUserData(){
      getUserInfo().then((res) => {
        if (res.message.status == 200 && res.data.weixinOpenid) {
            this.is_bind_wx = true;
        } 
      });
    }

  },
};
</script>

<style lang="scss" scoped>
::v-deep .mu-avatar{
  margin-right: 0.4333rem !important;
}
.mu-card-header {
  padding: 0.2667rem 0;

  .mu-avatar {
    width: 1.28rem !important;
    height: 1.28rem !important;
    margin-right: 0.5333rem;
  }
}

.mu-card-title {
  font-size: 0.48rem;
  color: #000000;
}

.mu-card-sub-title {
  font-size: 0.32rem;
  color: #000000;
  opacity: 0.8;
}

.mu-card-header {
  position: relative;

  .operate {
    position: absolute;
    right: 0.8108rem;

    img {
      width: 0.5389rem;
      height: 0.5389rem;
    }

    div {
      display: inline-block;
      margin-left: 0.4083rem;
    }
  }
}
.back-btn {
  position: absolute;
  top: 0.2667rem;
  left: 0.2667rem;
  z-index: 10;
  i {
    font-size: 0.48rem;
    color: #333;
  }
}
</style>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.mineBox {
  background-image: url("~@/assets/image/mine/mine-image_1.png");
  background-size: 100% 45%;
  background-repeat: no-repeat;
  background-color: #F4F4F5;
  padding: 0;
  height: calc(100vh - 1.8rem);

  .head {

    .user-info {
      display: flex;
      align-items: center;
      padding: 0.4054rem;
    }
  }

  .mineCard {
    //position: absolute;
    //top: 2.0rem;
    margin: 0 0.16rem;
    margin-bottom: 0.2533rem;
    width: calc(100% - (0.14rem * 2));
    height: 4rem;
    border-radius: 0.19rem;
    background-image: url("~@/assets/image/user/user-image_5.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 0 0.3rem;
    padding-left: 0.15rem;

    .card-text {
      padding: 0.5333rem 0.5533rem 0.2rem;
      font-size: 0.32rem;
      color: #E3E3E3;
    }

    .card-center,
    .card-bottom {
      display: flex;
      justify-content: space-between;
      padding: 0 0.5533rem 0.2rem;
    }

    .card-price,
    .card-cash {
      align-self: center;
    }

    .card-price {
      font-size: 0.7rem;
      font-weight: bold;
      color: white;
    }

    .card-cash {
      padding: 0.1rem 0.3rem;
      text-align: center;
      color: #244EE1;
      background-color: #FFFFFF;
      border-radius: 1rem;
      font-size: 0.2901rem;
    }

    .card-bottom {
      .card-info {
        width: 50%;

        p:nth-child(1) {
          color: #8FA5F4;
          font-size: 0.34rem;
        }

        p:nth-child(2) {
          color: #FFFFFF;
          font-size: 0.35rem;
        }
      }
    }

  }

  .list-item {
    width: calc(100% - (0.42rem * 2));
    height: 1.1533rem;
    background: #ffffff;
    border-radius: 0.1867rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4rem 0.4533rem;
    margin: 0 0.42rem;
    margin-bottom: 0.2667rem;

    .before {
      align-self: center;
      display: flex;

      img {
        width: 0.4054rem;
        height: 0.4054rem;
        align-self: center;
        margin-right: 0.2702rem;
      }
    ;
    }

    span {
      font-size: 0.3733rem;
      color: #444444;
    }

    .icon-box {
      font-size: 0.4267rem;
      color: #444444;
    }
  }

  .my-btn-box {
    margin-top: 0.6349rem;
    width: 100%;
    height: 1.2533rem;
    background: #ffffff;
    border-radius: 0.1867rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.3733rem;
    color: #444444;
  }
}
</style>
